import { baseStoreCreator } from '@/utils/store';

export interface SecurityPayload {
  employeeId: string,
  username: string;
  password: string;
  lastPasswordUpdate: string;
  isLoginLocked?: boolean;
  isMfaLocked?: boolean;
  requiredParticipantMfa?: boolean;
  mfaLockedTo?: string;
  fullName: string;
}

export const DEFAULT_VALUES: SecurityPayload = {
  employeeId: '',
  username: '',
  password: '',
  lastPasswordUpdate: '',
  isLoginLocked: undefined,
  isMfaLocked: undefined,
  requiredParticipantMfa: undefined,
  mfaLockedTo: '',
  fullName: '',
};

export const useStore = baseStoreCreator<SecurityPayload>(DEFAULT_VALUES);

export default useStore;
